import type { IconSvgObject } from './types';

const PopcornIcon: IconSvgObject = [
  ["path", { d: "M5 12L6.67845 20.3922C6.86542 21.3271 7.68625 22 8.63961 22H15.3604C16.3138 22 17.1346 21.3271 17.3216 20.3922L19 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.0228 3.0098C9.73094 0.680579 5.50526 2.67586 6.01269 6.00282C2.0713 5.95775 1.9589 12 5.90147 12L18.0748 12C21.9993 12 21.9623 5.92764 18.039 5.97291C18.5155 2.65667 14.3053 0.690008 12.0228 3.0098Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 12L14 22", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default PopcornIcon;
